module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-regular.42790023.woff";